<template>
  <button
    type="button"
    role="menuitem"
    :class="[
      'conference-text-menu flex w-full items-center gap-1 px-2.5 py-1.25 text-left transition focus-visible:ring-2 focus-visible:outline-none',
      toneClass,
      activeClass,
    ]"
  >
    <slot name="leading" />
    <span class="min-w-0 flex-1 truncate">
      <slot />
    </span>
    <slot name="trailing" />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    active?: boolean;
    tone?: 'chrome' | 'light';
  }>(),
  {
    active: false,
    tone: 'chrome',
  },
);

const toneClass = computed(() =>
  props.tone === 'light'
    ? 'text-conference-ink hover:bg-conference-accent-soft hover:text-conference-accent-text focus-visible:ring-conference-accent/20'
    : 'text-white hover:bg-conference-room hover:text-conference-accent-text focus-visible:ring-conference-accent/25',
);

const activeClass = computed(() => {
  if (!props.active) {
    return '';
  }

  return props.tone === 'light'
    ? 'bg-conference-accent-soft text-conference-accent-text'
    : 'bg-conference-room text-conference-accent-text';
});
</script>
